var GROWTH_CONFIG_DEFINATION = 'GROWTH_API_CONFIG';
/** For Front-end to utilize this growth apis */

var getConfigValueFromEnv = function getConfigValueFromEnv(key) {
  if (typeof GROWTH_API_CONFIG !== 'undefined') {
    var value = GROWTH_API_CONFIG[key];
    if (value) return value;
  }

  return '';
};

export { GROWTH_CONFIG_DEFINATION, getConfigValueFromEnv };
